import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./screens/authentication/Login";
import {
  selectIsAuthenticated,
  selectToken,
} from "./store/selectors/UserSelector";
import { useDispatch, useSelector } from "react-redux";
import { Dashboard } from "./screens/dashboard/Dashboard";
import { injectThemeVariables } from "./utils/Theme.css";
import { isTokenExpired } from "./helpers/ValidatorTokenHelpers";
import { logout } from "./store/slices/AuthSlice";
import ForgetPassword from "./screens/authentication/ForgetPassword";
import ResetPassword from "./screens/authentication/RestPassword";

function App() {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  // Check token expiration
  useEffect(() => {
    if (token) {
      const isExpired = isTokenExpired(token);
      if (isExpired) {
        dispatch(logout());
      }
    }
  }, [token, dispatch]);

  const isLoggedIn = isAuthenticated && token && !isTokenExpired(token);

  useEffect(() => {
    injectThemeVariables();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            isLoggedIn ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
          }
        />

        <Route
          path="/login"
          element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />}
        />

        <Route
          path="/dashboard/*"
          element={isLoggedIn ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route path="/forgot-password" element={<ForgetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
